var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCreate(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 512,
    enableBackground: "new 0 0 512 512",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 25.87h14.37c3.04 0 5.5-2.46 5.5-5.5V6c0-3.03-2.46-5.5-5.5-5.5H6A5.51 5.51 0 00.5 6v14.37c0 3.04 2.47 5.5 5.5 5.5zm2.7-14.18h2.99V8.7c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5v2.99h2.98c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5h-2.98v2.98c0 .83-.67 1.5-1.5 1.5s-1.5-.67-1.5-1.5v-2.98H8.7c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5z",
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 11.687a1.5 1.5 0 00-1.5 1.5V24c0 2.481-2.019 4.5-4.5 4.5H13.187a1.5 1.5 0 100 3H24c4.136 0 7.5-3.364 7.5-7.5V13.187a1.5 1.5 0 00-1.5-1.5z",
    "data-original": "#000000"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreate);
export default __webpack_public_path__ + "static/media/create.ed697b5d3ede62ac1e7d16dbd19ac482.svg";
export { ForwardRef as ReactComponent };